import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_bath: FaireCategoryEntity = {
  token: "catalog_cat_bath",
  type: "category",
  name: "Bath",
  count: 14,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
